import { useEffect, useState } from 'react';
import { GOOGLE_MAPS_API_KEY } from '@/config/constants';

const IMAGE_SIZE = 180;
const BUILDING_ZOOM = 19;

type SatelliteImageProps = {
  latitude?: number;
  longitude?: number;
};

const SatelliteImage = ({ latitude, longitude }: SatelliteImageProps) => {
  const [isError, setIsError] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const isCoordinatesAvailable = Boolean(latitude && longitude);

  useEffect(() => {
    if (isCoordinatesAvailable) {
      const url = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${BUILDING_ZOOM}&size=${IMAGE_SIZE}x${IMAGE_SIZE}&maptype=satellite&key=${GOOGLE_MAPS_API_KEY}`;
      setImageUrl(url);
    }
  }, [latitude, longitude, isCoordinatesAvailable]);

  if (!isCoordinatesAvailable || !imageUrl || isError) {
    return null;
  }

  return (
    <div className="absolute z-50 overflow-hidden text-center border border-solid rounded top-2 right-2 border-tertiary backdrop-blur-sm size-24 md:size-[180px]">
      {isError ? (
        <div className="flex items-center justify-center w-full h-full">
          <p className="text-body-2 text-tertiary">No satellite image available</p>
        </div>
      ) : (
        <img
          alt="Satellite view"
          src={imageUrl}
          className="object-cover w-full h-full"
          onError={() => setIsError(true)}
          referrerPolicy="no-referrer"
        />
      )}
    </div>
  );
};

export default SatelliteImage;
